var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 2H4C2.89778 2 2 2.89778 2 4V18H11.3333V4C11.3333 2.89778 10.4356 2 9.33333 2ZM6 14.6667H4V13.3333H6V14.6667ZM6 12H4V10.6667H6V12ZM6 9.33333H4V8H6V9.33333ZM6 6.66667H4V5.33333H6V6.66667ZM9.33333 14.6667H7.33333V13.3333H9.33333V14.6667ZM9.33333 12H7.33333V10.6667H9.33333V12ZM9.33333 9.33333H7.33333V8H9.33333V9.33333ZM9.33333 6.66667H7.33333V5.33333H9.33333V6.66667ZM16 5.33333H12.6667V18H18V7.33333C18 6.23111 17.1022 5.33333 16 5.33333ZM16 14.6667H14.6667V13.3333H16V14.6667ZM16 12H14.6667V10.6667H16V12ZM16 9.33333H14.6667V8H16V9.33333Z",
    fill: "#00C55D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBusiness);
export default __webpack_public_path__ + "static/media/ico-business.28b073129ef74a2a2e8ddf83851042f0.svg";
export { ForwardRef as ReactComponent };